"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _userstore = require("../legacy/stores/userstore");

var _userstore2 = _interopRequireDefault(_userstore);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (dispatch) {
    [_userstore2.default].forEach(function (store) {
        if (store.initReduxDispatch) {
            store.initReduxDispatch(dispatch);
        }
    });
};